/**
 * Animation to change hero image
 * Includes pausing when hovering over box or hero center bubble
 */

(() => {
  // set up
  const heroModule = document.querySelector('.module-hero');
  const heroboxGrid = document.querySelector('.module-heroboxes .herobox-grid');
  if (!heroModule || !heroboxGrid) return;

  const mainBubble = heroModule.querySelector('.hero-images-bubbles .circle-main');

  /**
   * mini header/boxes Intersection Observer
   */
  (() => {
    const toggleClass = (elem, className, add) => {
      document.querySelector(elem).classList[add ? 'add' : 'remove'](className);
    };

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const { isIntersecting } = entry;

        toggleClass('.module-hero', 'mini', isIntersecting);
        toggleClass('.herobox-row-wrapper', 'mini', isIntersecting);
        heroboxGrid.classList[isIntersecting ? 'add' : 'remove']('mini');
      });
    }, { threshold: 0.7 }).observe(document.querySelector('header'));
  })();

  // variables

  const boxes = heroboxGrid.querySelectorAll('.herobox');
  let currentBox = null;
  let boxIndex = 0;
  let intervalId;
  let isMouseOverBox = false;
  let currentTextClass;

  // functions

  // Swap boxes and update hero module
  const swapBoxes = (box) => {
    if (currentBox) currentBox.classList.remove('active');
    box.classList.add('active');
    heroModule.classList.add('nSwap');

    // Update hero module depending on active box
    setTimeout(() => {
      for (let i = 2; i <= 5; i += 1) {
        const { src } = box.querySelector(`.c${i}`);
        heroModule.querySelector(`.c${i} img`).src = src;
        heroModule.querySelector(`.c1 img:nth-of-type(${i - 1})`).src = src;
        const { href } = box;
        heroModule.querySelector('.c1 a').href = href;
        const { innerHTML } = box.querySelector('h2 span');
        heroModule.querySelector('.c1 a').innerHTML = /* html */`
          <h2>See Featured ${innerHTML}</h2>
          <p>Click Here</p>
        `;
      }

      currentBox = box;
      setTimeout(() => heroModule.classList.remove('nSwap'), 1000);
    }, 500);

    // Changes Header text
    const newTextClass = box.className.split(' ').find((className) => className.startsWith('herobox-')).replace('herobox', 'title');
    if (currentTextClass) {
      document.querySelector(`.${currentTextClass}`).classList.remove('nActive');
    }
    document.querySelector(`.${newTextClass}`).classList.add('nActive');
    document.querySelector('.title-0').classList.remove('nActive');
    currentTextClass = newTextClass;
    boxIndex = (boxIndex + 1) % boxes.length;
  };

  // Start and stop the interval
  const startInterval = () => {
    intervalId = setInterval(() => {
      if (!isMouseOverBox) swapBoxes(boxes[boxIndex]);
    }, 10000); // auto swap delay
  };
  const stopInterval = () => clearInterval(intervalId);

  // Animation Start
  setTimeout(() => {
    swapBoxes(boxes[boxIndex]);
    startInterval();

    boxes.forEach((box) => {
      box.addEventListener('mouseover', () => {
        if (box === currentBox) return;

        isMouseOverBox = true;
        stopInterval();
        swapBoxes(box);
      });

      box.addEventListener('mouseleave', () => {
        isMouseOverBox = false;

        if (intervalId) stopInterval();
        startInterval();
      });
    });

    mainBubble.addEventListener('mouseover', () => clearInterval(intervalId));
    mainBubble.addEventListener('mouseleave', () => startInterval());
  }, 10000); // Initial delay
})();
